import { calcMenuHeight } from './header-animation';

if ($(window).width() <= 768) {
  var header = document.getElementById('main_heading');

  const menuItemsWithChildren = document.querySelectorAll('.nav-mobile .menu-item-has-children');

  menuItemsWithChildren.forEach((item) => {
    const height = item.getBoundingClientRect().height;
    item.style.maxHeight = '4em';

    item.addEventListener('click', (event) => {
      // Check if we click in sub-menu
      const isSubMenuItem = event.target.parentElement.parentElement.classList.contains('sub-menu');
      if (isSubMenuItem) return;

      event.preventDefault();

      item.classList.toggle('menu-has-open-sub-menu');

      if (item.dataset.active === 'true') {
        item.style.maxHeight = '4em';
        item.dataset.active = 'false';
      } else {
        item.style.maxHeight = `${height}px`;
        item.dataset.active = 'true';
      }

      header.style.transform = 'translateY(' + calcMenuHeight() + 'px)';
    });
  });
}
